import React from 'react'
import { Cointainer, CustomNavLink, CustomNavLink1 } from '../../style/PMCStyle/PMCSidebar'
import { CustomDiv } from '../../style/shared'
import { PmsLogo } from '../../component/logo/Logo'
import '../../component/Sidebar/sidebar.css'

const DEFAULT_LABELS = {
  Cal: 'Calendar',
  User: 'People',
  Menu: 'Menu',
  Person: 'Person',
};

const getItemLabel = (item) => item.label || DEFAULT_LABELS[item.alt] || item.alt;

const NavItemCard = ({ item }) => (
  <div className="sidebar-nav-card">
    <img
      src={item.icon}
      className="sidebar-nav-icon"
      alt={item.alt}
    />
    <span className="sidebar-nav-label">{getItemLabel(item)}</span>
  </div>
);

export const PMCSidebar = ({config}) => {
    return (
        <Cointainer className='noAfter sidebar-panel'>
            <PmsLogo className="sidebar-logo sidebar-logo-pharmacy" />
            <CustomDiv className="sidebar-nav">
                {config.map((item, index) => {
                    const isActive = item.path && window.location.href.includes(item.path);
                    const key = item.path || `${item.alt}-${index}`;

                    return item.path ? (
                        <CustomNavLink
                            key={key}
                            to={item.path}
                            className={`sidebar-nav-link ${isActive ? 'active' : ''}`}
                        >
                            <NavItemCard item={item} />
                        </CustomNavLink>
                    ) : (
                        <CustomNavLink1 key={key} className="sidebar-nav-link">
                            <NavItemCard item={item} />
                        </CustomNavLink1>
                    );
                })}
            </CustomDiv>
        </Cointainer>
    );
}

export default PMCSidebar
